import axios from 'axios';
import useSWR from 'swr';

import { formatAndThrowApiError } from '@/helpers/api';

const useZealTasks = () => {
  const url = '/admin/zeal-task';
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });

  return swr;
};

const useZealBugReports = () => {
  const url = '/admin/zeal-bug-report';
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });

  return swr;
};

// The screenshot route needs the auth header, so an <img src> cannot load it
// directly: fetch the image and hand back an object URL for it.
const useZealScreenshot = (object) => {
  const swr = useSWR(object ? ['/admin/zeal-screenshot', object] : null, async ([url, object]) => {
    try {
      const result = await axios.get(url, { params: { object }, responseType: 'blob' });
      return URL.createObjectURL(result.data);
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });

  return swr;
};

const usePostZealIdea = () => {
  const postZealIdea = async (payload) => {
    try {
      const result = await axios.post('/admin/zeal-task/idea', payload);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };
  return postZealIdea;
};

const usePostZealBugReport = () => {
  const postZealBugReport = async (payload) => {
    try {
      const result = await axios.post('/admin/zeal-bug-report', payload);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };
  return postZealBugReport;
};

// `target` is `T-<n>` for an idea or `bug:<id>` for a bug report.
const useUploadZealScreenshot = () => {
  const uploadZealScreenshot = async (target, file) => {
    try {
      const formData = new FormData();
      formData.append('target', target);
      formData.append('file', file);
      const result = await axios.post('/admin/zeal-screenshot', formData);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };
  return uploadZealScreenshot;
};

export { useZealTasks, useZealBugReports, useZealScreenshot, usePostZealIdea, usePostZealBugReport, useUploadZealScreenshot };
